import React from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import TourLIst from "./section-components/tour-list";
import Subscribe from "./section-components/subscribe";
import Footer from "./global-components/footer";

const TourListPage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="اعلانات المعهد" />
      <TourLIst />
      <Subscribe />
      <Footer />
    </div>
  );
};

export default TourListPage;
